import { Tone } from "Components/UI/DataTable/cells";
import { Category964Enum } from "Shared/Types/fleetmanagementapi";

export const categoryTones: Record<Category964Enum, Tone> = {
  NEW: "success",
  IMPROVED: "success",
  UPDATE: "neutral",
  MAINTENANCE: "warning",
  DEPRECATED: "danger",
};
